
import curry from 'lodash/curry'
import Mustache from 'mustache'
import $ from 'jquery'
import { openModal } from '../ui/modal'

export const showErrorMessage = (err) => {
	let { $input, input } = err;
	if (!$input) {
		if (input) {
			$input = $(input);
			err.$input = $input;
		} else {
			return;
		}
	}

	const $formGroup = err.$input.closest('.field');
	$formGroup.find('.validation-error-msg').remove();
	$input.addClass('validation-error');
	const $msg = $('<span class="validation-error-msg"/>').html(err.message);
	const $modalOpenLink = $msg.find('.info-modal-open');

	if ($modalOpenLink.length) {
		$modalOpenLink.on('click', () => openModal($modalOpenLink, { compact: true, centerVertical: true }));
	}

	if ($input.closest('label').length) {
		$msg.insertAfter($input.closest('label'));
	} else {
		const id = $input.attr('id');
		if (id === 'kplussa-box') {
			$msg.insertAfter($input.closest('.form-control'));
		} else {
			$msg.insertAfter($input);
		}
	}
}

export const hideErrors = (form) => {
	$(form).find('.js-general-form-error').addClass('u-hidden');
}

export const showAlert = (template, err, $before) => {
	const $formGroup = err.$input.closest('.field');
	const $beforeElement = $before && $before.length ? $before : $formGroup;
	const $alertScope = $beforeElement.parent();
	const $existingAlert = $alertScope.find(`.validation-alert.alert-${err.type}`).first();

	if ($existingAlert.length < 1) {
		const $alert = $(Mustache.render(template, err));
		const $modalOpenLink = $alert.find('.info-modal-open');

		if ($modalOpenLink.length) {
			$modalOpenLink.on('click', () => openModal($modalOpenLink, { compact: true, centerVertical: true }));
		}

		$formGroup.siblings('.validation-alert').remove();
		$alert.insertBefore($beforeElement).slideDown('fast');
	}
}

export const setFormLoader = (form, params = {}) => {
	if (params.disableInputs) {
		// Disable inputs
		for (let input of form.elements) {
			input.readOnly = true;
		}
	}

	// Disable submit
	const submit = form.querySelector('input[type="submit"]');
	if (submit) {
		submit.disabled = true;
		submit.classList.add('a-button--loading');
	}
}

export const removeFormLoader = (form) => {
	// Enable inputs
	for (let input of form.elements) {
		input.readOnly = false;
	}

	// Enable submit
	const submit = form.querySelector('input[type="submit"]');
	if (submit) {
		submit.disabled = false;
		submit.classList.remove('a-button--loading');
	}
}

/**
 * @param {JQuery}
 * @param {Array<Object>} errors
 */
export const showValidationErrors = curry((form, errors) => {
	const $form = $(form);
	const alertTemplate = $('#mustache-alert').html();

	errors.filter(err => !err.hide)
		.forEach(err => {
			if (err.type === 'form') {
				const $generalError = $form.find('.js-general-form-error');
				if ($generalError.length) {
					$generalError.text(err.message).removeClass('u-hidden');
				}
				return;
			}

			let fieldLabel = ''
			if (err.field === 'pickuplocation') {
				err.field = 'deliverymethod'
				fieldLabel = 'Noutopiste'
			}

			if (err.field === 'message') {
				fieldLabel = 'Kenttä';
			}

			// Get all form elements for the given form.
			// Compare against the validation field name received from the backend to find the proper input with errors.
			const $inputs = $form.find(':input[type!=hidden]');
			const $input = $inputs.filter(function () { return this.name === err.field; }).first();

			const $formGroup = $input.closest('.field');
			const isProductField = typeof err.field === 'string' && err.field.indexOf('products') === 0;
			const isDeliveryField = !err.field || ['deliverymethod', 'pickuplocation'].indexOf(err.field) > -1;
			const isPaymentField = err.field === 'stage-payment-provider';
			const $shippingMethodsList = $form.find('.shipping-methods-list').first();
			const $paymentMethods = $form.find('.payment-methods-container').first();

			$input.closest('.checkout-oneclick-form').addClass('editing')
			const useAlertValidationError = $formGroup.hasClass('use-alert-validation-error');
			const $target = isProductField ? $formGroup : $formGroup.find('label');

			if (!$target.length && isDeliveryField && $shippingMethodsList.length) {
				const label = fieldLabel || 'Toimitustapa';
				err.message = err.message.replace('%s', label);
				err.$input = $input.length ? $input : $shippingMethodsList;
				err.type = 'danger';
				showAlert(alertTemplate, err, $shippingMethodsList);
				return;
			}

			if ((!$target.length || !$formGroup.length) && isPaymentField && $paymentMethods.length) {
				const label = fieldLabel || 'Maksutapa';
				err.message = err.message.replace('%s', label);
				err.$input = $input.length ? $input : $paymentMethods;
				err.type = 'danger';
				showAlert(alertTemplate, err, $paymentMethods);
				return;
			}

			$target.each(function() {
				const label = fieldLabel || $(this).data('field-label') || $(this).text().replace('*', '').replace(' (vapaaehtoinen)', '');
				err.message = err.message.replace('%s', label);
				err.$input = $input;

				if (isDeliveryField) {
					err.type = 'danger';
					showAlert(alertTemplate, err, $shippingMethodsList);
				} else if (isProductField || useAlertValidationError) {
					err.type = 'danger';
					showAlert(alertTemplate, err, $formGroup);
				} else {
					showErrorMessage(err);
				}
			})

		});
})

export function inputFilteringEvents(form) {
	const $form = $(form);
	const $inputs = $form.find('input');

	$inputs.each(function() {
		const $input = $(this);
		const inputName = $input.attr('name');

		switch (inputName) {
			case 'kplussa_number': {
				$input.on('input', function() {
					const $input = $(this);
					const inputValue = $input.val();
					let number = '';
					const value = String(inputValue).replace(/[^0-9]/g, '').trim().substring(0, 16);

					// If someone pastes full card number.
					if ((value.substring(0, 6) === '703240') && value.length >= 16) {
						number = value.substring(6, value.length);
					} else {
						number = value;
					}

					$input.val(number);
				});
				break;
			}

			default:
				break;
		}
	});
}

export default API => {

	const filterChildrenByParentValue = ($children, $parentElement) => {
		return $children.filter(function() {
			const conditionalValues = $(this).data('conditionalvalues').split(',');
			return conditionalValues.includes($parentElement.val());
		});
	}

	const updateConditionalFieldMarkup = ($el, $allChildren, $parentElement) => {
		const $filteredChildren = filterChildrenByParentValue($allChildren, $parentElement);
		if ($filteredChildren.length > 0) {
			$el.attr('data-validation', 'required');
			$el.val(0);
			$el.parents('.field').removeClass('hidden');
		} else {
			$el.attr('data-validation', '');
			$el.val(0);
			$el.parents('.field').addClass('hidden');
		}
		$el.html($filteredChildren);
	}

	API.filterConditionalFields = (formSelector) => {
		const $allConditionalFields = $(`${formSelector} [data-conditionalField]`)
		if ($allConditionalFields.length === 0) {
			return
		} else {
			$allConditionalFields.each((i, el) => {
				const parentName = $(el).data('conditionalfield');
				const $parentElement = $(`#${parentName}`);
				const $allChildren = $(el).children();

				$parentElement.on('change', function() {
					updateConditionalFieldMarkup($(el), $allChildren, $parentElement);

					const $conditionalFields = $allConditionalFields.filter(function() {
						return $(this).data('conditionalfield') === $(el).attr('id');
					});
					// update conditional "child" fields, e.g. when parent changes also sub-sub-categories are updated
					$conditionalFields.each(function(){
						updateConditionalFieldMarkup($(this), $(this).children(), $(el));
					});
				})
				updateConditionalFieldMarkup($(el), $allChildren, $parentElement); //update on page load
			});
		}
	}
}
